import { request } from '@/utils/request'

export function getUsersNames (ids) {
  return request({
    baseURL: import.meta.env.VITE_APP_LOGIN_API,
    url: 'rest/v1/auth/names',
    method: 'post',
    data: ids
  })
}
